import React from 'react';
import { SEMANTIC_HR_PAGE } from '../../../../content/enterpriseMessaging';

const platforms = [
  {
    name: 'Workday',
    badge: 'REST API warehouse',
    accent: 'border-l-amber-500',
    badgeClass: 'text-amber-800 bg-amber-50 ring-amber-200/80',
    description:
      'Unified Workday REST API data architecture with historical workforce tracking for point-in-time reporting, compliance, and governed reporting views.',
  },
  {
    name: 'SAP SuccessFactors',
    badge: 'OData warehouse',
    accent: 'border-l-sky-500',
    badgeClass: 'text-sky-800 bg-sky-50 ring-sky-200/80',
    description:
      'Structured SuccessFactors OData architecture with governed views for Employee Central, org data, and the same certified metrics surfaced in Power BI and copilot answers.',
  },
];

export default function HrisParity() {
  const copy = SEMANTIC_HR_PAGE;

  return (
    <section className="py-10 md:py-12">
      <div className="container-x">
        <div className="max-w-3xl">
          <p className="eyebrow">{copy.hrisEyebrow}</p>
          <h2 className="mt-3 text-3xl font-semibold tracking-tight text-ink-900 sm:text-4xl lg:text-[2.5rem] lg:leading-tight">
            {copy.hrisTitle}
          </h2>
          <p className="mt-5 text-lg leading-relaxed text-ink-600">{copy.hrisIntro}</p>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-4 md:grid-cols-2 md:gap-5 lg:mt-10">
          {platforms.map((platform) => (
            <article
              key={platform.name}
              className={`rounded-2xl border border-ink-200/80 bg-white/90 p-6 shadow-sm sm:p-7 border-l-[5px] ${platform.accent}`}
            >
              <div className="flex flex-wrap items-center gap-x-3 gap-y-2">
                <h3 className="text-lg font-semibold text-ink-900">{platform.name}</h3>
                <span
                  className={`rounded-md px-2.5 py-1 text-xs font-semibold uppercase tracking-wide ring-1 ring-inset ${platform.badgeClass}`}
                >
                  {platform.badge}
                </span>
              </div>
              <p className="mt-4 text-base leading-relaxed text-ink-600">{platform.description}</p>
            </article>
          ))}
        </div>

        <div className="mt-10 lg:mt-11">
          <div className="mb-5 flex flex-col gap-1 sm:flex-row sm:items-end sm:justify-between">
            <div>
              <p className="text-sm font-semibold uppercase tracking-[0.12em] text-ink-500">
                Reference entity coverage
              </p>
              <p className="mt-1 text-sm text-ink-600">
                Deploy on Workday, SuccessFactors, or both, with the same semantic definitions in demo and production.
              </p>
            </div>
          </div>

          <div className="overflow-hidden rounded-2xl border border-ink-200/80 bg-white shadow-sm">
            <div className="max-w-full min-w-0">
              <table className="w-full min-w-0 table-fixed text-left text-sm">
                <thead>
                  <tr className="border-b border-ink-100 bg-surface-subtle/80">
                    <th className="w-[22%] px-3 py-4 text-xs font-bold uppercase tracking-wider text-ink-500 sm:px-5">Platform</th>
                    <th className="w-[28%] px-3 py-4 text-xs font-bold uppercase tracking-wider text-ink-500 sm:px-5">Source</th>
                    <th className="px-3 py-4 text-xs font-bold uppercase tracking-wider text-ink-500 sm:px-5">
                      Governed entities
                    </th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-ink-100">
                  {copy.hrisEntityMap.map((row, i) => (
                    <tr key={row.platform} className={i % 2 === 0 ? 'bg-white' : 'bg-surface-subtle/40'}>
                      <td className="break-words px-3 py-4 font-semibold text-ink-900 sm:px-5">{row.platform}</td>
                      <td className="break-words px-3 py-4 text-ink-600 sm:px-5">{row.source}</td>
                      <td className="break-words px-3 py-4 leading-relaxed text-ink-600 sm:px-5">{row.entities}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
